import validation from './validation';
import eventBus from '../eventBus';

export default {
  mixins: [validation],

  methods: {
    defaultGoToNextStep() {
      this.$_validation_validate()
        .then(() => {
          eventBus.$emit('next-step');
        })
        .catch(() => {
          this.$refs.form.focusOnFirstError();
        });
    },
  },
};
